import React from 'react';
import { Input, NumberInput } from '../Antd';
import css from './css.less';
import { IInputType } from './type';
export { IInputType };
const LabelInput = (props) => {
  const { label, size, error, type, ...rest } = props;

  const top = React.useMemo(() => {
    if (error) {
      if (size === 'small') {
        return { top: '2px' };
      }
      return { top: '3px' };
    } else {
      if (size === 'small') {
        return { top: '-8px' };
      }
      return { top: '-8px' };
    }
  }, [size, error]);
  const paddingTop = React.useMemo(() => {
    if (error) {
      return { paddingTop: 10 };
    }
    return { paddingTop: 0 };
  }, [error]);

  const input = () => {
    if (type === IInputType.Number) {
      return (
        <NumberInput
          // decimalSeparator={0}
          precision={0}
          min={-9999999}
          size={size || 'default'}
          error={error}
          {...rest}
        />
      );
    }
    return <Input size={size || 'default'} error={error} {...rest} />;
  };
  return (
    <div className={css.container} style={{ ...paddingTop }}>
      <div className={css.label} style={{ ...top }}>
        {label}
      </div>
      {input()}
    </div>
  );
};
export default LabelInput;
